import { useEngineRules } from '../hooks/useEngineRules'
import { formatLevelExitsFrom } from './LevelExitsNote'

/**
 * The dated note on who decides which engine signals publish, beside
 * LevelExitsNote on the Track Record and on engine receipts. Hidden until a
 * trained model has decided live (phase2_model_from, from
 * /api/public/engine-rules): a model running in shadow changes nothing that
 * publishes, so there is nothing to date. If the fixed rule takes the
 * decision back, that date is added.
 */
export const phase2TrialNoteText = (modelFrom?: string | null, ruleAgainFrom?: string | null): string | null => {
  const from = modelFrom ? formatLevelExitsFrom(modelFrom) : null
  if (!from) return null
  const base =
    `From ${from}, a trained model (Phase 2) decides which engine signals publish; before that, a fixed rule did. ` +
    'Both verdicts are recorded on every signal.'
  const again = ruleAgainFrom ? formatLevelExitsFrom(ruleAgainFrom) : null
  return again ? `${base} From ${again}, the fixed rule decides again.` : base
}

const Phase2TrialNote = ({ className = '' }: { className?: string }) => {
  const rules = useEngineRules()
  const text = phase2TrialNoteText(rules?.phase2_model_from, rules?.phase2_rule_again_from)
  if (!text) return null
  return (
    <p className={`text-xs text-gray-500 ${className}`} data-testid="phase2-trial-note">
      {text}
    </p>
  )
}

export default Phase2TrialNote
